export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-200">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-open-line text-lg text-background-50"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">亲亲漫画网</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              专注<strong className="text-background-200">下拉式漫画阅读</strong>，免费日漫韩漫大全。每日更新热门连载，流畅的下拉式阅读体验，让好漫画一气呵成。全站免费、无广告，只为最纯粹的漫画阅读之旅。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li><a href="#hero" onClick={(e) => { e.preventDefault(); document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 no-underline cursor-pointer">首页</a></li>
              <li><a href="#about" onClick={(e) => { e.preventDefault(); document.querySelector('#about')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 no-underline cursor-pointer">关于亲亲</a></li>
              <li><a href="#ranking" onClick={(e) => { e.preventDefault(); document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 no-underline cursor-pointer">热门排行</a></li>
              <li><a href="#faq" onClick={(e) => { e.preventDefault(); document.querySelector('#faq')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 no-underline cursor-pointer">常见问题</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50 mb-4">内容分类</h4>
            <ul className="space-y-2.5">
              <li><a href="#cards" onClick={(e) => { e.preventDefault(); document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 no-underline cursor-pointer">热门推荐</a></li>
              <li><a href="#index" onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 no-underline cursor-pointer">分类索引</a></li>
              <li><a href="#carousel" onClick={(e) => { e.preventDefault(); document.querySelector('#carousel')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 no-underline cursor-pointer">焦点专题</a></li>
              <li><a href="#updates" onClick={(e) => { e.preventDefault(); document.querySelector('#updates')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 no-underline cursor-pointer">更新动态</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-500 leading-relaxed">
              合作伙伴区域，更多精彩内容即将入驻，敬请期待。
            </p>
          </div>
        </div>

        <div className="mt-10 md:mt-12 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2026 亲亲漫画网 · 免费下拉式漫画阅读平台 · 保留所有权利
          </p>
          <div className="flex items-center gap-5">
            <span className="text-xs text-background-500">下拉式漫画</span>
            <span className="text-xs text-background-500">免费追更</span>
            <span className="text-xs text-background-500">日漫韩漫大全</span>
          </div>
        </div>
      </div>
    </footer>
  );
}